module.exports = __webpack_public_path__ + "fonts/YekanBakhFaNumFat.338edf3.ttf";